import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TooltipIcon, LoaderButton } from 'ctia-ui';
import { formatDate } from 'helpers/DateHelper';
import { isCTIAUser, getFullName } from 'helpers/Users';
import { fetchRequestComments, postComment } from 'actions/comments';
import { FormControl } from 'react-bootstrap';

class Comments extends Component {
  constructor(props) {
    super(props);
    this.state = { text: '', isLoading: false };
  }

  componentDidMount() {
    if (isCTIAUser(this.props.user)) {
      this.fetchComments();
    }
  }

  fetchComments = () => {
    this.props.fetchRequestComments(this.props.request.id);
  };

  onTextChange = event => {
    const text = _.trimStart(event.target.value);
    this.setState({ text });
  };

  onSubmit = () => {
    this.setState({ isLoading: true });
    const { request, postComment } = this.props;
    const comment = _.trim(this.state.text);
    postComment(request.id, comment)
      .then(this.fetchComments)
      .then(() => {
        this.setState({ isLoading: false, text: '' });
      });
  };

  renderComments = () => {
    const { comments } = this.props;
    if (comments.data.length) {
      return comments.data.map((item, i) => {
        const postDate = formatDate(item.createdat);
        const submitter = getFullName(item.submitter);
        return (
          <div key={i}>
            <b>{submitter}</b> <i>({postDate})</i>:<p>{item.comment}</p>
          </div>
        );
      });
    }
    return null;
  };

  render() {
    const { user, comments } = this.props;

    if (!isCTIAUser(user) || !comments) return null;

    const count = comments.pager.TOTALRECORDS || 0;
    const { text, isLoading } = this.state;

    return (
      <div>
        <h4>
          Comments ({count}){' '}
          <TooltipIcon
            glyph="question-sign"
            tipText="You can leave comment about the request here"
          />
        </h4>
        {this.renderComments()}
        <FormControl
          componentClass="textarea"
          value={text}
          onChange={this.onTextChange}
          disabled={isLoading}
        />
        <LoaderButton
          bsStyle="primary"
          bsSize="small"
          text="Post comment"
          onClick={this.onSubmit}
          isLoading={isLoading}
          loadingText="Posting..."
          style={{ marginTop: 10 }}
          disabled={text.length < 3}
        />
      </div>
    );
  }
}

function mapStateToProps({ user, request, comments }) {
  return { user, request, comments };
}

export default connect(
  mapStateToProps,
  { fetchRequestComments, postComment }
)(Comments);



// WEBPACK FOOTER //
// ./src/components/Comments.js